import { create } from "zustand";
import { User } from "../types/user";
import { getUnifiedUsers } from "../services/userUnifiedService";

type UserStore = {
  users: User[];
  newUsers: User[];
  loading: boolean;
  error: string | null;
  fetchUsers: () => Promise<void>;
};

export const useUserStore = create<UserStore>((set) => ({
  users: [],
  newUsers: [],
  loading: false,
  error: null,

  fetchUsers: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getUnifiedUsers();

      const now = new Date();
      const cutoffDate = new Date();
      cutoffDate.setDate(now.getDate() - 30);

      // Sort by createdAt descending (newest first)
      const sortedUsers = [...data].sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      });

      // Filter users created in the last 30 days
      const newUsers = sortedUsers.filter(user => {
        const userDate = new Date(user.createdAt);
        return userDate >= cutoffDate;
      });

      set({
        users: sortedUsers,
        newUsers,
        loading: false
      });
    } catch (err: any) {
      set({ error: err.message || "Failed to fetch users", loading: false });
    }
  },
}));